<template>
    <v-card class="page mx-auto d-flex flex-column">
        <page-title :title="title" :info="info" :help="help"></page-title>

        <v-card-text v-show="HasError" class="pb-0">
            <error></error>
        </v-card-text>

        <v-card-text
		class="py-0 text" ref="card-text">
            <slot name="pageContainer"></slot>
        </v-card-text>
		<v-spacer></v-spacer>

		<v-card-actions class="pl-4">
			<slot name="pageActions"></slot>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

import namespace from '../store/namespace';

import PageTitle from './PageTitle.vue';
import Error from './Error.vue';


export default {
	name: 'Page',
	components: {
		PageTitle,
		Error,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		info: {
			type: String,
			default: '',
		},
		textHeight: {
			type: String,
			default: 'auto',
		},
		help: {
			required: false,
			default: null,
		},
	},
	computed: {
		...mapGetters(namespace.ERROR, ['HasError', 'Message']),
	},
	watch: {
		textHeight() {
			this.$refs['card-text'].style.height = this.textHeight;
		},
	},
	mounted() {
		this.$refs['card-text'].style.height = this.textHeight;
	},
};
</script>

<style lang="scss" scoped>
.page {
	width:100%;
	height:100%;
	min-height: 300px;
    max-width: 1450px;
}

.text {
	min-height: 150px;
	overflow: hidden;
	overflow-y: auto;
}
</style>
